module.exports = __webpack_public_path__ + "img/horizontal_4_6_r_pp3_9006.b6e9db89.png";